import { useMutation } from '@tanstack/react-query';
import { createPartnerPlanCheckout } from '../services/partnerPlans';
import { buildPartnerPlanCheckoutReturnUrls } from '../utils/partnerSubscriptionPlans';

export const usePartnerPlansCheckoutMutation = (options = {}) =>
  useMutation({
    mutationFn: async ({ successUrl, cancelUrl, failureUrl } = {}) => {
      const returnUrls = buildPartnerPlanCheckoutReturnUrls();
      const result = await createPartnerPlanCheckout({
        successUrl: successUrl || returnUrls.successUrl,
        cancelUrl: cancelUrl || returnUrls.cancelUrl,
        failureUrl: failureUrl || returnUrls.failureUrl,
      });

      if (!result.success) {
        throw new Error(result.message || 'Failed to start plan checkout');
      }

      if (!result.checkoutUrl) {
        throw new Error('Checkout URL was not returned by the server');
      }

      return result;
    },
    ...options,
  });
